import React from 'react'

const Paginator = ({ pager, onSetCurrentPage }) => {
    const renderPager = () => {
        if (pager.totalPages < 2) {
            return null
        }

        let firstPage = pager.currentPage + 1 - 2
        if (firstPage < 1) {
            firstPage = 1
        }
        let lastPage = pager.currentPage + 3
        if (lastPage > pager.totalPages) {
            lastPage = pager.totalPages
        }
        let allPages = []
        for (let page = firstPage; page <= lastPage; page = page + 1) {
            allPages.push(
                <div
                    key={page}
                    className={`page ${page - 1 === pager.currentPage ? 'active' : ''}`}
                    onClick={() => onSetCurrentPage(page - 1)}>
                    {page}
                </div>
            )
        }
        return <div className="page-numbers">{allPages}</div>
    }

    const renderCounts = () => {
        const firstPage = pager.currentPage * pager.itemsPerPage + 1
        let lastPage = pager.currentPage * pager.itemsPerPage + pager.itemsPerPage
        if (lastPage > pager.totalItems) {
            lastPage = pager.totalItems
        }
        return (
            <div className="counts">
                Showing {firstPage} - {lastPage} of {pager.totalItems}
            </div>
        )
    }

    if (!pager) {
        return null
    }

    return (
        <div className="paginator">
            {renderPager()}
            {renderCounts()}
        </div>
    )
}

export default Paginator
